import { AiNotePadRef } from './consts';




export default function (editor, opts = {}) {
  const { label, category } = opts;
  const bm = editor.BlockManager;

const style = `<style>
  .${AiNotePadRef} .notepad-wrapper {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: 4rem;
    height: 4rem;
    z-index: 9999;
    cursor: move; 
  }

  .${AiNotePadRef} .notepad-toggle {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #2563eb, #3b82f6);
    color: #fff;
    font-size: 1.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: move; 
    box-shadow: 0 6px 15px rgba(0,0,0,0.2);
    transition: box-shadow 0.25s ease-in-out;
    border: none;
  }

  .${AiNotePadRef} .notepad-toggle:hover {
    box-shadow: 0 8px 20px rgba(0,0,0,0.3);
  }

  .${AiNotePadRef} .notepad-toggle.dragging {
    box-shadow: 0 10px 30px rgba(0,0,0,0.4);
  }

  .${AiNotePadRef} .notepad-message-wrapper {
    position: absolute;
    bottom: calc(100% + 1rem);
    right: 0;
    width: 480px;
    height: 520px;
    background: #fff;
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(0,0,0,0.25);
    transform: scale(0);
    transform-origin: bottom right;
    transition: transform 0.25s ease-in-out;
    display: flex;
    flex-direction: column;
  }

  .${AiNotePadRef} .notepad-message-wrapper.show {
    transform: scale(1);
  }

  
  .${AiNotePadRef} .notepad-message-header {
    background: #2563eb;
    color: #fff;
    padding: 12px 20px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: move; 
    user-select: none;
  }

  .${AiNotePadRef} .notepad-message-close {
    border: none;
    background: transparent;
    font-size: 1.5rem;
    color: #fff;
    cursor: pointer;
    transition: 0.2s;
  }

  .${AiNotePadRef} .notepad-message-close:hover {
    color: #f87171;
  }

  .${AiNotePadRef} .notes-list-view {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 1rem;
    gap: 0.75rem;
  }

  .${AiNotePadRef} .note-card {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 1rem;
    cursor: pointer;
    transition: all 0.2s;
  }

  .${AiNotePadRef} .note-card:hover {
    background: #f3f4f6;
    border-color: #2563eb;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }

  .${AiNotePadRef} .note-card-title {
    font-weight: 600;
    font-size: 16px;
    color: #1f2937;
    margin-bottom: 0.5rem;
  }

  .${AiNotePadRef} .note-card-preview {
    font-size: 14px;
    color: #6b7280;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .${AiNotePadRef} .add-note-card {
    background: #eff6ff;
    border: 2px dashed #3b82f6;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80px;
    font-weight: 600;
    color: #2563eb;
  }

  .${AiNotePadRef} .add-note-card:hover {
    background: #dbeafe;
    border-color: #2563eb;
  }

 
  .${AiNotePadRef} .note-editor-view {
    flex: 1;
    display: none;
    flex-direction: column;
  }

  .${AiNotePadRef} .note-editor-view.active {
    display: flex;
    height:200px;
  }

  .${AiNotePadRef} .note-editor-header {
    background: #f3f4f6;
    padding: 12px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    border-bottom: 1px solid #e5e7eb;
  }

  .${AiNotePadRef} .back-to-list {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #6b7280;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s;
  }

  .${AiNotePadRef} .back-to-list:hover {
    background: #e5e7eb;
    color: #1f2937;
  }

  .${AiNotePadRef} .current-note-title {
    flex: 1;
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
  }

  .${AiNotePadRef} .delete-note-btn {
    background: #fee2e2;
    border: none;
    color: #dc2626;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
  }

  .${AiNotePadRef} .delete-note-btn:hover {
    background: #fecaca;
  }

  .${AiNotePadRef} .notepad-toolbar {
    background: #f3f4f6;
    padding: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    border-bottom: 1px solid #e5e7eb;
  }

  .${AiNotePadRef} .notepad-toolbar button {
    border: none;
    background: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.2s;
  }

  .${AiNotePadRef} .notepad-toolbar button:hover {
    background: #e5e7eb;
  }

  .${AiNotePadRef} #save-status {
    margin-left: auto;
    font-size: 12px;
    color: #6b7280;
  }

  .${AiNotePadRef} .note-editor {
    flex: 1;
    padding: 16px;
    outline: none;
    font-size: 15px;
    line-height: 1.6;
    overflow-y: auto;
    background: #fff;
    height:200px;
    text-color: #1f2937;
  }

 
  .${AiNotePadRef} .empty-notes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    text-align: center;
    color: #9ca3af;
  }

  .${AiNotePadRef} .empty-notes-icon {
    font-size: 48px;
    margin-bottom: 1rem;
  }

  .${AiNotePadRef} .empty-notes-text {
    font-size: 16px;
    margin-bottom: 0.5rem;
    color: #6b7280;
  }
</style>`;

  bm.add(AiNotePadRef, {
    label: `<i class="webconnect-file-earmark-text"></i><div class="gjs-block-label">${label}</div>`,
    category: category,
    content: `
   <div class="${AiNotePadRef}" data-gjs-type="${AiNotePadRef}" data-js="${AiNotePadRef}" data-notes-wrapper>
        <div class="notepad-wrapper">
          <button class="notepad-toggle">📝</button>
          <div class="notepad-message-wrapper">
            
            <div class="notepad-message-header">
              <h3 id="notepad-title">My Notes</h3>
              <button class="notepad-message-close">×</button>
            </div>

            <div class="notes-list-view" id="notes-list-view">
            </div>

            <div class="note-editor-view" id="note-editor-view">
              <div class="note-editor-header">
                <button class="back-to-list">←</button>
                <span class="current-note-title" id="current-note-title">Untitled Note</span>
                <button class="delete-note-btn">🗑️ Delete</button>
              </div>

              <div class="notepad-toolbar">
                <button onclick="document.execCommand('bold', false, null)"><b>B</b></button>
                <button onclick="document.execCommand('italic', false, null)"><i>I</i></button>
                <button onclick="document.execCommand('underline', false, null)"><u>U</u></button>
                <button onclick="document.execCommand('insertunorderedlist', false, null)">• List</button>
                <button onclick="document.execCommand('insertorderedlist', false, null)">1. List</button>
                <span id="save-status"></span>
              </div>

              <div id="note-editor" class="note-editor" contenteditable="true"></div>
            </div>
          </div>
        </div>
      </div>
    ${style}
    `,
    render: ({ model, className }) => `
      <div class="${className}-label ${className}__wrap">
        ${model.get("label")}
      </div>
      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="true">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="How to use ${label}?"></i>
        </a>
      </span>
    `,
  });
}